{#if either href link}
  <a href={href} target={target} class="hitbox">
    {>content}
  </a>
{else}
  {> content}
{/if}

{#snippet content}
  <i class="{ui}icon" part="icon"></i>
{/snippet}
